import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import PoolBookingListTable from './Components/PoolBookingListTable'

const PoolBookingList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Pool Booking List</HeadingOne>
                    <AddItemBtn url="add-pool-booking" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <PoolBookingListTable />
            </div>
        </PageBody>
    )
}

export default PoolBookingList
